import React from "react";
import "./index.less";
import { Link, useLocation } from "react-router-dom"; // 添加 useLocation

const BottomPage = (props) => {
  const location = useLocation(); // 获取当前路由信息

  const navList = [
    {
      id: "main-nav",
      children: [
        {
          path: "/",
          key: "/",
          name: "首页",
        },
        {
          path: "/product",
          key: "product",
          name: "产品服务",
        },
        {
          path: "/about",
          key: "about",
          name: "关于我们",
        },
      ],
    },
  ];
  const navOtherList = [
    {
      id: "main-other-nav",
      children: [
        {
          path: "/case/operations",
          key: "operations",
          name: "GPU服务器运维案例",
        },
        {
          path: "/case/reconfiguration",
          key: "reconfiguration",
          name: "GPU服务器改配案例",
        },
        {
          path: "/case/removal",
          key: "removal",
          name: "GPU服务器搬迁案例",
        },
      ],
    },
  ];
  const navOtherSolutionList = [
    {
      id: "main-other-solution-nav",
      children: [
        {
          path: "/solution/delivery",
          key: "delivery",
          name: "交付解决方案",
        },
        {
          path: "/solution/devOps",
          key: "devOps",
          name: "运维解决方案",
        },
        {
          path: "/solution/repair",
          key: "repair",
          name: "维修解决方案",
        },
      ],
    },
  ];
  // 判断链接是否激活
  const isActiveLink = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <footer className="global-footer">
      <div className="themesCube">
        <div className="mid-Link">
          <div className="other-nav">
            <dt>解决方案</dt>
            {navOtherSolutionList.map((val) => (
              <dl key={val.id} className="item-cube">
                {val.children.map((v) => (
                  <dd key={v.key}>
                    <Link
                      to={v.path}
                      className={isActiveLink(v.path) ? "active" : ""}
                    >
                      {v.name}
                    </Link>
                  </dd>
                ))}
              </dl>
            ))}
          </div>
          <div className="other-nav">
            <dt>服务案例</dt>
            {navOtherList.map((val) => (
              <dl key={val.id} className="item-cube">
                {val.children.map((v) => (
                  <dd key={v.key}>
                    <Link
                      to={v.path}
                      className={isActiveLink(v.path) ? "active" : ""}
                    >
                      {v.name}
                    </Link>
                  </dd>
                ))}
              </dl>
            ))}
          </div>

          <div className="nav">
            <dt>快速导航</dt>
            {navList.map((val) => (
              <dl key={val.id} className="item-in">
                {val.children.map((v) => (
                  <dd key={v.key}>
                    <Link
                      to={v.path}
                      className={isActiveLink(v.path) ? "active" : ""}
                    >
                      {v.name}
                    </Link>
                  </dd>
                ))}
              </dl>
            ))}
          </div>
          <div className="bottom-nav">
            <dt>联系</dt>
            <dd>邮箱:business@wecloudcore.com</dd>
            <dd>电话:19120399082</dd>
            <dd>地址:广东省珠海市横琴新区兴澳路9号中信粤澳大厦1403</dd>
          </div>
        </div>
      </div>
      <div className="bottom-stowage">
        <div className="middle">
          <Link to="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">版权所有 广东维云芯信息科技有限公司. All rights reserved.粤ICP备2025504852号</Link>
        </div>
      </div>
    </footer>
  );
};

export default BottomPage;
